// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__KpDnW","content":"Footer_content__sRLWS","linksContainer":"Footer_linksContainer__oAVNQ","link":"Footer_link__TBOP7"};